import { Content } from "@carbon/react";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'

import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { checkToken } from "./apiClient/apiClient";
import './styles/App.scss';
import RouteGuard from "./guards/RouteGuard.js";
import FooterLayout from "./layouts/Footer/index.js"
import HeaderLayout from "./layouts/Header/index.js"
import NotificationsLayout from "./layouts/NotificationsLayout/index.js";
import Dashboard from "./pages/Dashboard/index.js";

import Login from "./pages/Login/index.js";
import Notifications from "./pages/Notifications/index.js";
import ProfileLayout from "./pages/Profile/index.js";
import { selectUser } from "./features/user/userSlice.js";
import { loadPersistedAuthThunk } from "./features/user/userThunks.js";

function App() {
    const dispatch = useDispatch()
    const userState = useSelector(selectUser)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        dispatch(loadPersistedAuthThunk())
    }, [dispatch])

    useEffect(() => {
        if (location.pathname !== "/login" && !checkToken(userState.token_refresh)) {
            navigate('/login')
        }
    }, [location.pathname, userState.token_refresh, navigate])

    return (
        <div className="main-layout">
            <HeaderLayout></HeaderLayout>
            <NotificationsLayout></NotificationsLayout>
            <Content className="main-container">
                <Routes>
                    <Route exact path="/login" element={<Login />} />
                    <Route path='/*' element={
                        <RouteGuard userState={userState}>
                            <Routes>
                                <Route path="/" element={<Navigate to="/dashboard" />} />
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/telemetry" element={<Dashboard />} />
                                <Route path="/profile"
                                    element={<ProfileLayout />} />
                                <Route exact path="/notifications"
                                    element={<Notifications />} />
                                <Route exact path="/*"
                                    element={<Navigate to="/dashboard" />} />
                            </Routes>
                        </RouteGuard>

                    }>
                    </Route>
                </Routes>
            </Content>
            <FooterLayout />
        </div>
    );
}

export default App;
